import Vue from 'vue';

export const mutations = {
  SET_VARIABLES(state, variables) {
    Vue.set(state, 'variables', variables);
  },

  SHOW_SIDE(state, visibility) {
    state.showSide = visibility;
  },

  SET_PROJECT_CONFIG(state, config) {
    Vue.set(state, 'config', config);
  },

  SET_PROJECT_VARIABLES(state, variables) {
    Vue.set(state, 'projectVariables', variables);
  },

  SET_LAYOUT(state, layoutName) {
    state.layout = layoutName;
  },

  SET_CSTM(state, cstm) {
    state.cstm = cstm;
  },

  SET_RESPONSE(state, apiResponse) {
    state.apiResponse = apiResponse;
  },

  SET_LANGUAGE(state, language) {
    state.language = language;
  },

  SET_ERROR(state, error) {
    state.errors.unshift(error);
  },

  SET_REPORT(state, report) {
    Vue.set(state, 'report', report);
  },

  HIDE_ERROR(state) {
    Vue.set(state, 'errors', []);
  },

  SET_DEVICE_TYPE(state, deviceType) {
    state.device = deviceType;
  },

  SET_DATA_PROTECTION_STATEMENT(state, statement) {
    state.dataProtectionStatement = statement;
  },

  SET_DATA_PROTECTION_STATEMENT_MODAL_VISIBILITY(state, value) {
    state.showDataProtectionModal = value;
  },
  SET_DATA_PROTECTION_STATEMENT_ACCEPTED(state, value) {
    state.dataProtectionStatement.accepted = value;
  },
  SET_CONTACTING_STATEMENT_ACCEPTED(state, value) {
    state.dataProtectionStatement.contactingAccepted = value;
  },
  SET_MODULES(state, modules) {
    state.modules = [...modules];
  },

  SET_MODULE_CONTAINERS(state, containers) {
    state.moduleContainers = [...containers];
  },

  SET_FINISHED_MODULES(state, modules) {
    state.finishedModules = [...modules];
  },

  SET_ACTIVE_MODULE(state, module) {
    state.activeModule = module;
  },

  SET_ACTIVE_MODULE_CONTAINER(state, container) {
    state.activeModuleContainer = container;
  },

  SET_SESSION_URL(state, sessionURL) {
    state.sessionURL = sessionURL;
  },

  FINISH_LOADING(state) {
    state.loading = false;
  },

  SET_NAV_VISIBILITY(state, visibility) {
    state.showNav = !!visibility;
  },

  SET_OVERLAY(state, value) {
    state.appearance.overlay = value;
  },
  SET_LOGO(state, type) {
    state.appearance.logo = state.variables.logo[type];
  },

  SET_PROGRESS_VISIBILITY(state, visibility) {
    state.appearance.showProgress = visibility;
  },

  SET_PROGRESS(state, progress) {
    const currentProfileId = state.activeProfile.id;
    Vue.set(state.progress, `${currentProfileId}`, progress);
  },

  SET_USER_DATA(state, { key, value }) {
    Vue.set(state.userData, key, value);
  },

  SET_ALL_USERDATA(state, userData) {
    const clientData = {};
    const clientDataKeys = Object.keys(state.userData);
    clientDataKeys.forEach((clientDataKey) => {
      const clientDataValue = state.userData[clientDataKey];
      clientData[clientDataKey] = clientDataValue;
    });
    const mergedData = { ...clientData, ...userData };
    Vue.set(state, 'userData', mergedData);
  },

  SET_LOGGED_IN(state, isLoggedIn) {
    state.isLoggedIn = isLoggedIn;
  },

  REQUEST_FEEDBACK(state, value) {
    state.feedbackRequested = value;
  },
  SET_VIDEO_MODULE(state, module) {
    state.videoModule = module;
  },

  FEEDBACK_SEEN(state, value) {
    state.feedbackSeen = value;
  },

  ADD_VIDEOS(state, videos) {
    state.videos.push(...videos);
  },

  SET_ON_SITE(state, isOnSite) {
    state.isOnSite = isOnSite;
  },

  SET_ACTIVE_PROFILE(state, profile) {
    state.activeProfile = profile;
  },

  SET_PROFILES(state, profiles) {
    state.profiles = [...profiles];
  },

  SET_FORMS(state, forms) {
    state.componentNameMap = forms;
  },

  PROGRESS_ACTIVE_MODULE_CONTAINER(state) {
    const { activeModuleContainer } = state;
    activeModuleContainer.step();

    Vue.set(state, 'activeModuleContainer', activeModuleContainer);
  },

  SET_SHOW_VIDEO_ARCHIVE(state, showArchive) {
    state.showVideoArchive = showArchive;
  },

  SET_TEXTS(state, texts) {
    state.texts = texts;
  },

  SET_REPORT_BINDINGS(state, bindings) {
    state.reportBindings = bindings;
  },

  SET_PASSWORT_REQUIREMENTS(state, passwordRequirements) {
    state.passwordRequirements = passwordRequirements;
  },

  SET_TRANSITION_STATUS(state, inTransition) {
    state.inTransition = inTransition;
  },
};
